
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19","height":"19","viewBox":"0 0 19 19"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-width":"1.5","data-name":"vuesax/twotone/status-up"}},[_c('path',{attrs:{"d":"M5.447 14.369V12.73","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M9.5 14.368v-3.277M13.553 14.369V9.445","opacity":".4"}}),_c('g',{attrs:{"data-name":"Group 709","opacity":".4"}},[_c('path',{attrs:{"data-name":"Vector","d":"M13.554 4.631l-.365.427A14.948 14.948 0 015.447 9.84"}}),_c('path',{attrs:{"data-name":"Vector","d":"M11.235 4.631h2.32v2.312","stroke-linejoin":"round"}})]),_c('path',{attrs:{"data-name":"Vector","d":"M7.125 17.416h4.75c3.958 0 5.542-1.583 5.542-5.542V7.125c-.001-3.959-1.584-5.542-5.542-5.542h-4.75c-3.959 0-5.542 1.583-5.542 5.542v4.75c0 3.958 1.583 5.541 5.542 5.541z","stroke-linejoin":"round"}})])])
          )
        }
      }
    